export const BOOKINGS_QUERY_KEY = 'bookings'
export const BOOKINGS_INFINITE_QUERY_KEY = 'bookingsInfinite'
export const BOOKING_HISTORY_QUERY_KEY = 'bookingHistory'
export const BOOKING_AS_CLIENT_QUERY_KEY = 'bookingAsClient'
export const BOOKINGS_BY_IDS_QUERY_KEY = 'bookingsByIds'
export const AVAILABILITY_FOR_BOOKING_QUERY_KEY = 'availabilityForBooking'
export const AVAILABILITY_CLIENTS_FOR_BOOKING_QUERY_KEY = 'availabilityClientsForBooking'
